import { Singleton } from 'framework/di';

import type {
  VolumeBundleAction,
  VolumeBundleDefaultSettings,
  VolumeBundleTemplateName,
} from './volume-bundle.model';

@Singleton()
export class VolumeBundleConstants {
  readonly VOLUME_BUNDLE_TYPE = 'volume';
  readonly KEY_VOLUME_BUNDLE = 'volumeBundleKey';

  readonly KEYBOARD_ACTIVATION_KEYS: readonly string[] = ['Enter', ' ', 'Spacebar'];

  readonly SELECTORS = {
    PRE_FIX_CLASS_VOLUME_BUNDLE_MODAL: 'boost-sd__volume-bundle-modal-',
    MODAL_WRAPPER: '.boost-sd__modal-wrapper',
    RECOMMENDATION: '.boost-sd__recommendation',
    VOLUME_BUNDLE_ID_CONTAINER_PRODUCT: 'boost-sd__volume-bundle-product',
    VOLUME_RADIO: '.boost-sd__volume-bundle-menu-radio',
    VOLUME_RADIO_LABEL: '.boost-sd__volume-bundle-menu-label',
    VOLUME_MENU: '.boost-sd__volume-bundle-menu',
    VOLUME_MENU_ITEM: '.boost-sd__volume-bundle-menu-item',
    DROPDOWN_ITEM: '.boost-sd__dropdown-volume-item',
    BUTTON_ADD_BUNDLE_TO_CART: '.boost-sd__volume-bundle-menu-add-to-cart',
    VOLUME_BUNDLE_BLOCK: '.boost-sd__widget-volume-bundle',
  } as const;

  readonly CSS_CLASSES = {
    DROPDOWN_LIST: 'boost-sd__dropdown-option-list',
    DROPDOWN_LIST_OPEN: 'boost-sd__dropdown-option-list--open',
    DROPDOWN_SELECT_OPTION: 'boost-sd__dropdown-selected-option',
    DROPDOWN_CONTAINER: 'boost-sd__dropdown-volume',
    DROPDOWN_SELECT_OPTION_SELECTED: 'boost-sd__dropdown-option--selected',
    VOLUME_RADIO_CHECKED: 'boost-sd__volume-bundle-menu-radio--checked',
  } as const;

  readonly BUNDLE_ACTION: Record<'initData' | 'changeVariant' | 'clickRadio', VolumeBundleAction> =
    {
      initData: 'init-data',
      changeVariant: 'change-variant',
      clickRadio: 'click-radio',
    } as const;

  readonly BUNDLE_TEMPLATE_NAME: Record<
    'bundleBlock' | 'bundleProduct' | 'bundlePopup',
    VolumeBundleTemplateName
  > = {
    bundleBlock: 'recommendationVolumeBundleBlock',
    bundleProduct: 'recommendationVolumeBundleProduct',
    bundlePopup: 'recommendationVolumeBundlePopup',
  } as const;

  readonly SESSION_KEYS = {
    DATA_SESSION: 'VolumeBundleDataSession',
    OPENING: 'VolumeBundleOpening',
    COMBOBOX_BUTTON: 'VolumeBundleComboBox',
    RADIO: 'VolumeBundleRadio',
  } as const;

  readonly DEFAULT_SETTINGS: VolumeBundleDefaultSettings = {
    bundleBadgeColor: '#111111',
    bundleBadgeText: 'Most popular',
    bundleBadgeTextColor: '#FFFFFF',
    bundleImageData: '',
    bundleImageLink: '',
    bundleImageType: 'single',
    titleName: 'Buy more, save more',
    templateType: 'default',
    titleAlignment: 'center',
    titleTextColor: '#3D4246',
    titleFont: 'Poppins',
    titleTextTransform: 'uppercase',
    titleFontStyle: 'regular',
    titleFontSize: 14,
    buttonBackgroundColor: '#111111',
    buttonText: 'Add bundle to cart',
    buttonTextColor: '#FFFFFF',
    description: 'Buy {{quantity}} items and save {{discount}}',
    isDefault: false,
  };
}
